export default {
    error: {
        abort_403_message: 'ການເຂົ້າເຖິງຖືກປະຕິເສດ. ທ່ານອາດຈະບໍ່ມີສິດທີ່ເໝາະສົມໃນການເຂົ້າເຖິງໜ້ານີ້.',
        abort_403_text: 'ບໍ່ມີສິດ',
        abort_404_message: 'ໜ້າທີ່ທ່ານກຳລັງຊອກຫາອາດຈະຖືກລຶບ ປ່ຽນຊື່ ຫຼື ບໍ່ສາມາດໃຊ້ງານໄດ້ຊົ່ວຄາວ.',
        abort_404_text: 'ບໍ່ພົບໜ້າ',
        something_went_wrong: 'ເກີດຄວາມຜິດພາດ!',
        required: {
            address_in_cambodia: 'ຕ້ອງລະບຸທີ່ຢູ່',
            email: 'ຕ້ອງລະບຸອີເມວ',
            first_name: 'ຕ້ອງລະບຸຊື່',
            gender: 'ຕ້ອງລະບຸເພດ',
            identity_date: 'ຕ້ອງລະບຸວັນທີອອກບັດປະຈຳຕົວ',
            identity_image_back: 'ຕ້ອງລະບຸຮູບດ້ານຫຼັງບັດປະຈຳຕົວ',
            identity_image_front: 'ຕ້ອງລະບຸຮູບດ້ານໜ້າບັດປະຈຳຕົວ',
            identity_issued_date: 'ຕ້ອງລະບຸວັນທີອອກບັດປະຈຳຕົວ',
            identity_number: 'ຕ້ອງລະບຸເລກບັດປະຈຳຕົວ',
            last_name: 'ຕ້ອງລະບຸນາມສະກຸນ',
            nationality: 'ຕ້ອງລະບຸສັນຊາດ',
            passport_image_front: 'ຕ້ອງລະບຸຮູບດ້ານໜ້າໜັງສືເດີນທາງ',
            passport_image_back: 'ຕ້ອງລະບຸຮູບດ້ານຫຼັງໜັງສືເດີນທາງ',
            passport_number: 'ຕ້ອງລະບຸເລກໜັງສືເດີນທາງ',
            password: 'ຕ້ອງລະບຸລະຫັດຜ່ານ',
        },
        saving: 'ເກີດຄວາມຜິດພາດໃນການບັນທຶກ'
    },
    label: {
        about: "ກ່ຽວກັບພວກເຮົາ",
        action: "ການປະຕິບັດ",
        add: "ເພີ່ມ",
        address: "ທີ່ຢູ່",
        address_in_cambodia: "ທີ່ຢູ່ໃນກຳປູເຈຍ",
        admin_dashboard: "ແຜງຄວບຄຸມຜູ້ບໍລິຫານ",
        agree_to: "ຂ້ອຍຍອມຮັບ",
        all: "ທັງໝົດ",
        already_have_account: "ມີບັນຊີແລ້ວບໍ? ເຂົ້າສູ່ລະບົບ.",
        amendment: "ການແກ້ໄຂ",
        amendment_date: "ຂໍຂະຫຍາຍວັນທີ",
        amendment_office: "ຂໍປ່ຽນດ່ານຊາຍແດນ",
        amount: "ຈຳນວນເງິນ",
        app_dashboard: "ແຜງຄວບຄຸມແອັບພລິເຄຊັນ",
        app_name: "e-Customs",
        application: "ໃບສະໝັກ",
        application_report: "ລາຍງານໃບສະໝັກ",
        applications: "ໃບສະໝັກ",
        approve: "ອະນຸມັດ",
        approve_changed_border_gate: "ອະນຸມັດການປ່ຽນດ່ານຊາຍແດນ",
        approve_extended_date_of_entry: "ອະນຸມັດການຂະຫຍາຍວັນທີເຂົ້າ",
        approve_extended_date_of_exit: "ອະນຸມັດການຂະຫຍາຍວັນທີອອກ",
        asterisk: "ຈຳເປັນ",
        attachment: "ໄຟລ໌ແນບ",
        back: "ກັບຄືນ",
        back_side: "ດ້ານຫຼັງ",
        between: "ລະຫວ່າງ",
        border_pass_date: "ວັນທີອອກໃບຜ່ານແດນ",
        border_pass_number: "ເລກໃບຜ່ານແດນ",
        brand: "ຍີ່ຫໍ້",
        browse_your_device: "ເລືອກຈາກອຸປະກອນຂອງທ່ານ",
        by_user: "ໂດຍຜູ້ໃຊ້",
        change_border_gate_of_entry: "ປ່ຽນດ່ານເຂົ້າ",
        change_border_gate_of_exit: "ປ່ຽນດ່ານອອກ",
        change_image: "ປ່ຽນຮູບພາບ",
        changed_at: "ປ່ຽນແປງເມື່ອ",
        choose: "ເລືອກ",
        choose_document: "ເລືອກໄຟລ໌",
        choose_driver: "ເລືອກຄົນຂັບ",
        choose_image: "ເລືອກຮູບພາບ",
        choose_vehicle: "ເລືອກຍານພາຫະນະ",
        city: "ເມືອງ",
        close: "ປິດ",
        code: "ລະຫັດ",
        collapse: "ຫຍໍ້",
        color: "ສີ",
        company_address: "ທີ່ຢູ່ບໍລິສັດ",
        company_code: "ລະຫັດບໍລິສັດ",
        company_information: "ຂໍ້ມູນບໍລິສັດ",
        company_name: "ຊື່ບໍລິສັດ",
        confirm: "ຢືນຢັນ",
        confirm_delete: "ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການລຶບ?",
        confirm_password: "ຢືນຢັນລະຫັດຜ່ານ",
        contain: "ປະກອບດ້ວຍ",
        create: "ສ້າງ",
        create_application: "ສ້າງໃບສະໝັກ",
        created_at: "ສ້າງເມື່ອ",
        criteria: "ເງື່ອນໄຂ",
        currency: "ສະກຸນເງິນ",
        customs_registration: "ການລົງທະບຽນສຸນລະກາກອນ",
        dashboard: "ແຜງຄວບຄຸມ",
        date: "ວັນທີ",
        declaration: "ໃບແຈ້ງ",
        declaration_chart: "ແຜນວາດໃບແຈ້ງ",
        declaration_status: "ໃບສະໝັກຂອງຂ້ອຍ",
        declaration_status_today: "ໃບສະໝັກຂອງຂ້ອຍມື້ນີ້",
        declarations: "ໃບແຈ້ງ",
        decline: "ປະຕິເສດ",
        decline_changed_border_gate: "ປະຕິເສດການປ່ຽນດ່ານຊາຍແດນ",
        decline_extended_date_of_entry: "ປະຕິເສດການຂະຫຍາຍວັນທີເຂົ້າ",
        decline_extended_date_of_exit: "ປະຕິເສດການຂະຫຍາຍວັນທີອອກ",
        delete: "ລຶບ",
        delete_success: "ລຶບສຳເລັດ",
        deleted_at: "ລຶບເມື່ອ",
        description: "ຄຳອະທິບາຍ",
        destination: "ຈຸດໝາຍປາຍທາງ",
        destination_assess: "ປະເມີນຈຸດໝາຍປາຍທາງ",
        destination_change: "ປ່ຽນຈຸດໝາຍປາຍທາງ",
        destination_office_code: "ລະຫັດສຳນັກງານຈຸດໝາຍປາຍທາງ",
        destination_office_date: "ວັນທີຈຸດໝາຍປາຍທາງ",
        destination_office_name: "ສຳນັກງານຈຸດໝາຍປາຍທາງ",
        destination_assess_status: "ສະຖານະການປະເມີນຈຸດໝາຍປາຍທາງ",
        document_size: "ຂະໜາດເອກະສານຕ້ອງນ້ອຍກວ່າ ຫຼື ເທົ່າກັບ 5MB.",
        dont_have: "ບໍ່ມີ",
        download: "ດາວໂຫຼດ",
        driver: "ຄົນຂັບ",
        driver_information: "ຂໍ້ມູນຄົນຂັບ",
        drivers: "ຄົນຂັບ",
        driving_license: "ໃບຂັບຂີ່",
        driving_license_image_back: "ຮູບດ້ານຫຼັງໃບຂັບຂີ່",
        driving_license_image_front: "ຮູບດ້ານໜ້າໃບຂັບຂີ່",
        driving_license_photo: "ຮູບໃບຂັບຂີ່",
        edit: "ແກ້ໄຂ",
        email: "อີເມວ",
        empty_data: "ບໍ່ມີຂໍ້ມູນທີ່ຈະສະແດງ",
        engine_number: "ເລກເຄື່ອງຈັກ",
        enrouting: "ລະຫວ່າງເດີນທາງ",
        entry: "ເຂົ້າ",
        entry_date: "ວັນທີເຂົ້າ",
        entry_office_code: "ລະຫັດສຳນັກງານເຂົ້າ",
        entry_office_name: "ຊື່ສຳນັກງານເຂົ້າ",
        entry_vehicles: "ຍານພາຫະນະເຂົ້າ",
        entry_vehicles_today: "ຍານພາຫະນະເຂົ້າມື້ນີ້",
        equal: "ເທົ່າກັບ",
        exit: "ອອກ",
        exit_date: "ວັນທີອອກ",
        exit_office_code: "ລະຫັດສຳນັກງານອອກ",
        exit_office_name: "ຊື່ສຳນັກງານອອກ",
        exit_vehicles: "ຍານພາຫະນະອອກ",
        exit_vehicles_today: "ຍານພາຫະນະອອກມື້ນີ້",
        expand: "ຂະຫຍາຍ",
        expired_date: "ວັນໝົດອາຍຸ",
        extended_date_of_entry: "ຂະຫຍາຍວັນທີເຂົ້າ",
        extended_date_of_exit: "ຂະຫຍາຍວັນທີອອກ",
        female: "ຍິງ",
        file_name: "ຊື່ໄຟລ໌",
        filter: "ກັ່ນຕອງ",
        first_name: "ຊື່",
        forgot_password: "ລືມລະຫັດຜ່ານ?",
        frame_number: "ເລກຖັງ",
        fraud: "ການສໍ້ໂກງ",
        from: "ຈາກ",
        from_date: "ຈາກວັນທີ",
        front_side: "ດ້ານໜ້າ",
        fullname: "ຊື່-ນາມສະກຸນ",
        gender: "ເພດ",
        greater_than: "ໃຫຍ່ກວ່າ",
        greater_than_or_equal: "ໃຫຍ່ກວ່າ ຫຼື ເທົ່າກັບ",
        guarantee_information: "ຂໍ້ມູນການຮັບປະກັນ",
        guarantee_information_invalid: "ຂໍ້ມູນການຮັບປະກັນບໍ່ຖືກຕ້ອງ",
        have: "ມີ",
        having_passport: "ມີໜັງສືເດີນທາງບໍ?",
        home: "ໜ້າຫຼັກ",
        i_am_also_a_driver: "ທ່ານເປັນຄົນຂັບດ້ວຍບໍ?",
        i_am_also_driver: "ຂ້ອຍເປັນຄົນຂັບດ້ວຍ",
        id: "ໄອດີ",
        identity_card: "บັດປະຈຳຕົວ",
        identity_card_expired_date: "ວັນໝົດອາຍຸບັດປະຈຳຕົວ",
        identity_card_photo: "ຮູບບັດປະຈຳຕົວ",
        identity_date: "ວັນທີອອກບັດປະຈຳຕົວ",
        identity_image_back: "ຮູບດ້ານຫຼັງບັດປະຈຳຕົວ",
        identity_image_front: "ຮູບດ້ານໜ້າບັດປະຈຳຕົວ",
        identity_number: "ເລກບັດປະຈຳຕົວ",
        image_back: "ຮູບດ້ານຫຼັງ",
        image_front: "ຮູບດ້ານໜ້າ",
        image_size: "ຂະໜາດຮູບພາບຕ້ອງນ້ອຍກວ່າ ຫຼື ເທົ່າກັບ 2MB.",
        input_information_invalid: "ຂໍ້ມູນທີ່ປ້ອນບໍ່ຖືກຕ້ອງ",
        insurance_company_code: "ລະຫັດບໍລິສັດປະກັນໄພ",
        insurance_company_name: "ຊື່ບໍລິສັດປະກັນໄພ",
        insurance_date: "ວັນທີປະກັນໄພ",
        insurance_number: "ເລກປະກັນໄພ",
        is_required: "ຈຳເປັນ",
        issued_date: "ວັນທີອອກ",
        last_name: "ນາມສະກຸນ",
        leave_page_subtitle: "ທ່ານມີການປ່ຽນແປງທີ່ຍັງບໍ່ທັນບັນທຶກ!",
        leave_page_title: "ທ່ານຕ້ອງການອອກຈາກໜ້ານີ້ແທ້ບໍ?",
        length_of_stay: "ໄລຍະເວລາການພັກເຊົາ",
        less_than: "ນ້ອຍກວ່າ",
        less_than_or_equal: "ນ້ອຍກວ່າ ຫຼື ເທົ່າກັບ",
        list: "ລາຍການ",
        loading: "ກຳລັງດຶງຂໍ້ມູນ...",
        lodgement: "ການຍື່ນເອກະສານ",
        lodgement_assess: "ປະເມີນການຍື່ນເອກະສານ",
        lodgement_assess_approve: "ສຳນັກງານຍື່ນເອກະສານອະນຸມັດ",
        lodgement_assess_reject: "ສຳນັກງານຍື່ນເອກະສານປະຕິເສດ",
        lodgement_office_code: "ລະຫັດສຳນັກງານຍື່ນເອກະສານ",
        lodgement_office_date: "ວັນທີຍື່ນເອກະສານ",
        lodgement_office_name: "ສຳນັກງານຍື່ນເອກະສານ",
        lodgement_assess_status: "ສະຖານະການປະເມີນການຍື່ນເອກະສານ",
        login: "ເຂົ້າສູ່ລະບົບ",
        login_description: "ເຂົ້າສູ່ລະບົບເພື່ອເລີ່ມເຊສຊັນຂອງທ່ານ",
        login_information: "ຂໍ້ມູນການເຂົ້າສູ່ລະບົບ",
        male: "ຊາຍ",
        months: ["ມັງກອນ","ກຸມພາ","ມີນາ","ເມສາ","ພຶດສະພາ","ມິຖຸນາ","ກໍລະກົດ","ສິງຫາ","ກັນຍາ","ຕຸລາ","ພະຈິກ","ທັນວາ"],
        more_info: "ຂໍ້ມູນເພີ່ມເຕີມ",
        my_profile: "ໂປຣໄຟລ໌ຂອງຂ້ອຍ",
        n0: "ລຳດັບ",
        name: "ຊື່",
        nationality: "ສັນຊາດ",
        next: "ຕໍ່ໄປ",
        no: "ບໍ່",
        no_application: "ທ່ານຍັງບໍ່ມີໃບສະໝັກ",
        no_data: "ບໍ່ມີຂໍ້ມູນທີ່ກົງກັບການຄົ້ນຫາຂອງທ່ານ",
        no_image: "ບໍ່ມີຮູບພາບ",
        no_overstay: "ບໍ່ມີໃບແຈ້ງພັກເກີນກຳນົດ",
        no_recently_declaration: "ບໍ່ມີໃບແຈ້ງລ່າສຸດ",
        not_equal: "ບໍ່ເທົ່າກັບ",
        number: "ເລກ",
        office: "ສຳນັກງານ",
        office_code: "ລະຫັດສຳນັກງານ",
        officer: "ເຈົ້າໜ້າທີ່",
        ok: "ຕົກລົງ",
        other: "ເອກະສານອື່ນໆ",
        other_attachment_title: "ໄຟລ໌ແນບຕ້ອງເປັນໄຟລ໌ຮູບພາບ ແລະ ມີຂະໜາດນ້ອຍກວ່າ 5 MB.",
        other_document: "ເອກະສານອື່ນໆ",
        other_file_criteria: "ປະເພດໄຟລ໌ທີ່ອະນຸຍາດ: jpeg, png, jpg, pdf ແລະ ຂະໜາດ: 10MB",
        other_information: "ຂໍ້ມູນອື່ນໆ",
        over_stay_applications: "ໃບແຈ້ງພັກເກີນກຳນົດ",
        overstay: "ພັກເກີນກຳນົດ",
        owner: "ເຈົ້າຂອງ",
        owner_also_driver: "ເຈົ້າຂອງເປັນຄົນຂັບດ້ວຍ",
        owner_border_pass: "ໃບຜ່ານແດນຂອງເຈົ້າຂອງ",
        owner_confirm: "ທ່ານເປັນເຈົ້າຂອງບໍ?",
        owner_information: "ຂໍ້ມູນເຈົ້າຂອງ",
        owner_passport: "ໜັງສືເດີນທາງຂອງເຈົ້າຂອງ",
        passport: "ໜັງສືເດີນທາງ",
        passport_date: "ວັນທີໜັງສືເດີນທາງ",
        passport_expired_date: "ວັນໝົດອາຍຸໜັງສືເດີນທາງ",
        passport_image_back: "ຮູບດ້ານຫຼັງໜັງສືເດີນທາງ",
        passport_issued_date: "ວັນທີອອກໜັງສືເດີນທາງ",
        passport_number: "ເລກໜັງສືເດີນທາງ",
        passport_photo: "ຮູບໜັງສືເດີນທາງ",
        password: "ລະຫັດຜ່ານ",
        password_confirmation: "ຢືນຢັນລະຫັດຜ່ານ",
        penalize: "ລົງໂທດ",
        phone: "ໂທລະສັບ",
        plate_number: "ເລກທະບຽນລົດ",
        print: "ພິມ",
        profile: "ໂປຣໄຟລ໌",
        qrcode: "ລະຫັດ QR",
        reason: "ເຫດຜົນ",
        receipt_number: "ເລກໃບຮັບເງິນ",
        recent_declaration: "ໃບແຈ້ງລ່າສຸດ",
        register: "ລົງທະບຽນ",
        register_date: "ວັນທີລົງທະບຽນ",
        register_new_account: "ລົງທະບຽນບັນຊີໃໝ່",
        register_number: "ເລກລົງທະບຽນ",
        register_type: "ປະເພດການລົງທະບຽນ",
        register_year: "ປີທີ່ລົງທະບຽນ",
        reject: "ປະຕິເສດ",
        reload: "ໂຫຼດໃໝ່",
        remove: "ລຶບອອກ",
        report: "ລາຍງານ",
        request_change: "ຂໍປ່ຽນແປງ",
        request_change_entry_date: "ຂໍປ່ຽນວັນທີເຂົ້າ",
        request_change_entry_office: "ຂໍປ່ຽນສຳນັກງານເຂົ້າ",
        request_change_exit_date: "ຂໍປ່ຽນວັນທີອອກ",
        request_change_exit_office: "ຂໍປ່ຽນສຳນັກງານອອກ",
        request_changed_border_gate: "ຂໍປ່ຽນດ່ານຊາຍແດນ",
        request_extended_date_of_entry: "ຂໍຂະຫຍາຍວັນທີເຂົ້າ",
        request_extended_date_of_exit: "ຂໍຂະຫຍາຍວັນທີອອກ",
        reset_password: "ຕັ້ງລະຫັດຜ່ານໃໝ່",
        resolve: "ແກ້ໄຂ",
        restore: "ກູ້ຄືນ",
        result: "ຜົນລັບ",
        return_home: "ກັບໄປໜ້າຫຼັກ",
        save: "ບັນທຶກ",
        save_continue: "ບັນທຶກ ແລະ ດຳເນີນການຕໍ່",
        scan: "ສະແກນ",
        search: "ຄົ້ນຫາ",
        search_application: "ຄົ້ນຫາໃບສະໝັກ",
        search_driver: "ຄົ້ນຫາຄົນຂັບ",
        search_not_found: "ບໍ່ພົບໃບສະໝັກ",
        search_vehicle: "ຄົ້ນຫາຍານພາຫະນະ",
        security_returned: "ການຮັບປະກັນນີ້ຖືກຄືນແລ້ວ",
        select: "ເລືອກ",
        select_driver: "ກະລຸນາເລືອກຄົນຂັບ",
        select_vehicle: "ກະລຸນາເລືອກຍານພາຫະນະ",
        send: "ສົ່ງ",
        serial: "ຊີເຣຍວ",
        setting: "ການຕັ້ງຄ່າ",
        setup_my_profile: "ຕັ້ງຄ່າໂປຣໄຟລ໌ຂອງຂ້ອຍ",
        sign_in: "ເຂົ້າສູ່ລະບົບ",
        size: "ຂະໜາດ",
        status: "ສະຖານະ",
        steer: "ພວງມາໄລ",
        submit: "ສົ່ງ",
        temporary_export: "ສົ່ງອອກຊົ່ວຄາວ",
        temporary_import: "ນຳເຂົ້າຊົ່ວຄາວ",
        temporary_vehicle: "ຍານພາຫະນະຊົ່ວຄາວ",
        terms_conditions: "ຂໍ້ກຳນົດ ແລະ ເງື່ອນໄຂ",
        timeline: "ໄລຍະເວລາ",
        to: "ຫາ",
        to_date: "ຫາ",
        today_entry: "ເຂົ້າມື້ນີ້",
        today_exit: "ອອກມື້ນີ້",
        total_declaration: "ໃບແຈ້ງທັງໝົດ",
        total_vehicle: "ຍານພາຫະນະທັງໝົດ",
        type: "ປະເພດ",
        update: "ອັບເດດ",
        update_profile: "ອັບເດດໂປຣໄຟລ໌",
        updated_at: "ອັບເດດເມື່ອ",
        valid_from: "ມີຜົນຕັ້ງແຕ່",
        valid_to: "ມີຜົນຮອດ",
        value_1: "ຄ່າທີ 1",
        value_2: "ຄ່າທີ 2",
        vehicle: "ຍານພາຫະນະ",
        vehicle_and_driver: "ຍານພາຫະນະ ແລະ ຄົນຂັບ",
        vehicle_chart: "ແຜນວາດຍານພາຫະນະ",
        vehicle_identitation_back: "ຮູບດ້ານຫຼັງເອກະສານຍານພາຫະນະ",
        vehicle_identitation_front: "ຮູບດ້ານໜ້າເອກະສານຍານພາຫະນະ",
        vehicle_identity_photo: "ຮູບເອກະສານຍານພາຫະນະ",
        vehicle_information: "ຂໍ້ມູນຍານພາຫະນະ",
        vehicle_report: "ລາຍງານຍານພາຫະນະ",
        vehicle_type: "ປະເພດຍານພາຫະນະ",
        vehicles: "ຍານພາຫະນະ",
        view: "ເບິ່ງ",
        view_attachment: "ເບິ່ງໄຟລ໌ແນບ",
        view_detail: "ເບິ່ງລາຍລະອຽດ",
        view_document: "ເບິ່ງເອກະສານ",
        view_image: "ເບິ່ງຮູບພາບ",
        year: "ປີ",
        yes: "ແມ່ນ",
        your_email: "ອີເມວຂອງທ່ານ",
        your_information: "ຂໍ້ມູນຂອງທ່ານ",
        your_password: "ລະຫັດຜ່ານຂອງທ່ານ",
        zip: "ລະຫັດໄປສະນີ",
        pending: "ລໍຖ້າດຳເນີນການ",
        edit_detail: "ແກ້ໄຂລາຍລະອຽດ",
        owners: "ເຈົ້າຂອງ",
        search_owner: "ຄົ້ນຫາເຈົ້າຂອງ",
        choose_owner: "ເລືອກເຈົ້າຂອງ",
        select_owner: "ກະລຸນາເລືອກເຈົ້າຂອງ",
        declined: "ປະຕິເສດແລ້ວ",
        destination_approved: 'ສຳນັກງານຈຸດໝາຍປາຍທາງອະນຸມັດແລ້ວ',
    },
    message: {
        already_declaration: "ແຈ້ງໄປແລ້ວ!",
        approve_amendment: "ທ່ານຕ້ອງການອະນຸມັດຄຳຂໍນີ້ບໍ?",
        click_to_view: "ກົດເພື່ອເບິ່ງໄຟລ໌ແນບ",
        decline_amendment: "ທ່ານຕ້ອງການປະຕິເສດຄຳຂໍນີ້ບໍ?",
        instruction_info: "ກະລຸນາກົດປຸ່ມຕົກລົງ ລະບົບຈະພາທ່ານໄປກໍານຂໍ້ມູນໃຫ້ສົມບູນ.",
        no_driver: "ທ່ານຍັງບໍ່ມີຂໍ້ມູນຄົນຂັບ!",
        no_result: "ບໍ່ມີຜົນລັບ!",
        no_vehicle: "ທ່ານຍັງບໍ່ມີຂໍ້ມູນຍານພາຫະນະ!",
        not_update_passport: "ທ່ານຍັງບໍ່ທັນກໍານຂໍ້ມູນໜັງສືເດີນທາງໃຫ້ສົມບູນ!",
        not_update_profile: "ທ່ານຍັງບໍ່ທັນອັບເດດໂປຣໄຟລ໌!",
        profile_completion_message: "ໂປຣໄຟລ໌ຂອງທ່ານຍັງບໍ່ສົມບູນສຳລັບການສະໝັກ. ກະລຸນາຕັ້ງຄ່າໂປຣໄຟລ໌ຂອງທ່ານ!",
        profile_completion_title: "ແຈ້ງເຕືອນ!",
        profile_success: "ບັນທຶກໂປຣໄຟລ໌ສຳເລັດ!",
        required_if_no_identity_card: "ຂໍ້ມູນນີ້ຈະຕ້ອງລະບຸຖ້າບໍ່ມີບັດປະຈຳຕົວ",
        required_if_no_passport: "ຂໍ້ມູນນີ້ຈະຕ້ອງລະບຸຖ້າບໍ່ມີໜັງສືເດີນທາງ",
        success: "ບັນທຶກເອກະສານສຳເລັດ!",
        verify_phone: "ພວກເຮົາຈະຢືນຢັນບັນຊີຂອງທ່ານດ້ວຍເບີໂທລະສັບນີ້ ກະລຸນາກວດສອບວ່າຖືກຕ້ອງ.",
        please_complete_declaration_owner_first: 'ກະລຸນາກໍານຂໍ້ມູນເຈົ້າຂອງໃຫ້ສົມບູນກ່ອນ!',
        owner_success: "ບັນທຶກເຈົ້າຂອງສຳເລັດ!",
        driver_success: "ບັນທຶກຄົນຂັບສຳເລັດ!",
        vehicle_success: "ບັນທຶກຍານພາຫະນະສຳເລັດ!",
    },
    validation: {
        attributes: {
            address: "ທີ່ຢູ່",
            address_in_cambodia: "ທີ່ຢູ່ໃນກຳປູເຈຍ",
            attachment: "ໄຟລ໌ແນບ",
            border_pass_date: "ວັນທີໃບຜ່ານແດນ",
            border_pass_number: "ເລກໃບຜ່ານແດນ",
            owner_border_pass_number: "ເລກໃບຜ່ານແດນ",
            brand: "ຍີ່ຫໍ້",
            color: "ສີ",
            company_code_v1: "ລະຫັດບໍລິສັດ",
            destination_entry_date: "ວັນທີເຂົ້າ",
            destination_entry_office_name: "ຊື່ສຳນັກງານເຂົ້າ",
            destination_exit_date: "ວັນທີອອກ",
            destination_exit_office_name: "ຊື່ສຳນັກງານອອກ",
            destination_office_code_v1: "ລະຫັດສຳນັກງານຈຸດໝາຍປາຍທາງ",
            destination_office_date_v1: "ວັນທີສຳນັກງານຈຸດໝາຍປາຍທາງ",
            destination_office_date_v2: "ວັນທີສຳນັກງານຈຸດໝາຍປາຍທາງ",
            driver_address_in_cambodia: "ທີ່ຢູ່ໃນກຳປູເຈຍ",
            driver_border_pass_date: "ວັນທີໃບຜ່ານແດນ",
            driver_border_pass_number: "ເລກໃບຜ່ານແດນ",
            driver_first_name: "ຊື່",
            driver_gender: "ເພດ",
            driver_last_name: "ນາມສະກຸນ",
            driver_nationality: "ສັນຊາດ",
            driver_passport_expired_date: "ວັນໝົດອາຍຸໜັງສືເດີນທາງ",
            driver_passport_issued_date: "ວັນທີອອກໜັງສືເດີນທາງ",
            driver_passport_number: "ເລກໜັງສືເດີນທາງ",
            driving_license_image_back: "ຮູບດ້ານຫຼັງໃບຂັບຂີ່",
            driving_license_image_front: "ຮູບດ້ານໜ້າໃບຂັບຂີ່",
            engine_number: "ເລກເຄື່ອງຈັກ",
            entry_date: "ວັນທີເຂົ້າ",
            entry_office_name: "ຊື່ສຳນັກງານເຂົ້າ",
            exit_date: "ວັນທີອອກ",
            exit_office_name: "ຊື່ສຳນັກງານອອກ",
            first_name: "ຊື່",
            frame_number: "ເລກຖັງ",
            fraud_code: "ລະຫັດການສໍ້ໂກງ",
            fraud_name: "ຊື່ການສໍ້ໂກງ",
            fraud_valid_from: "ການສໍ້ໂກງມີຜົນຕັ້ງແຕ່",
            fraud_valid_to: "ການສໍ້ໂກງມີຜົນຮອດ",
            from_date: "ຈາກວັນທີ",
            full_name: "ຊື່-ນາມສະກຸນ",
            fullname: "ຊື່-ນາມສະກຸນ",
            fullname_v1: "ຊື່-ນາມສະກຸນ",
            gender: "ເພດ",
            gender_v1: "ເພດ",
            identity_date: "ວັນທີບັດປະຈຳຕົວ",
            identity_date_expire: "ວັນໝົດອາຍຸບັດປະຈຳຕົວ",
            identity_image_back: "ຮູບດ້ານຫຼັງບັດປະຈຳຕົວ",
            identity_image_front: "ຮູບດ້ານໜ້າບັດປະຈຳຕົວ",
            identity_number: "ເລກບັດປະຈຳຕົວ",
            identity_v1: "བັດປະຈຳຕົວ",
            insurance_company_code: "ລະຫັດບໍລິສັດປະກັນໄພ",
            insurance_company_name: "ຊື່ບໍລິສັດປະກັນໄພ",
            insurance_date: "ວັນທີປະກັນໄພ",
            insurance_number: "ເລກປະກັນໄພ",
            last_name: "ນາມສະກຸນ",
            lodgement_office_code_v1: "ລະຫັດສຳນັກງານຍື່ນເອກະສານ",
            lodgement_office_date_v1: "ວັນທີສຳນັກງານຍື່ນເອກະສານ",
            lodgement_office_date_v2: "ວັນທີສຳນັກງານຍື່ນເອກະສານ",
            nationality: "ສັນຊາດ",
            nationality_v1: "ສັນຊາດ",
            office_code: "ລະຫັດສຳนັກງານ",
            other: "ເອກະສານອື່ນໆ",
            owner_border_pass_date: "ວັນທີໃບຜ່ານແດນ",
            owner_border_pass_v1: "ໃບຜ່ານແດນຂອງເຈົ້າຂອງ",
            owner_passport_number: "ເລກໜັງສືເດີນທາງຂອງເຈົ້າຂອງ",
            owner_passport_v1: "ໜັງສືເດີນທາງຂອງເຈົ້າຂອງ",
            passport_expired_date: "ວັນໝົດອາຍຸໜັງສືເດີນທາງ",
            passport_image_back: "ຮູບດ້ານຫຼັງໜັງສືເດີນທາງ",
            passport_image_front: "ຮູບດ້ານໜ້າໜັງສືເດີນທາງ",
            passport_issued_date: "ວັນທີອອກໜັງສືເດີນທາງ",
            passport_number: "ເລກໜັງສືເດີນທາງ",
            passport_v1: "ໜັງສືເດີນທາງ",
            plate_number: "ເລກທະບຽນລົດ",
            profile_address: "ທີ່ຢູ່",
            profile_driving_license_image_back: "ຮູບດ້ານຫຼັງໃບຂັບຂີ່",
            profile_driving_license_image_front: "ຮູບດ້ານໜ້າໃບຂັບຂີ່",
            profile_first_name: "ຊື່",
            profile_gender: "ເພດ",
            profile_identity_date: "ວັນທີບັດປະຈຳຕົວ",
            profile_identity_date_expire: "ວັນໝົດອາຍຸບັດປະຈຳຕົວ",
            profile_identity_image_back: "ຮູບດ້ານຫຼັງບັດປະຈຳຕົວ",
            profile_identity_image_front: "ຮູບດ້ານໜ້າບັດປະຈຳຕົວ",
            profile_identity_number: "ເລກບັດປະຈຳຕົວ",
            profile_last_name: "ນາມສະກຸນ",
            profile_nationality: "ສັນຊາດ",
            profile_passport_image_back: "ຮູບດ້ານຫຼັງໜັງສືເດີນທາງ",
            profile_passport_image_front: "ຮູບດ້ານໜ້າໜັງສືເດີນທາງ",
            register_type: "ປະເພດການລົງທະບຽນ",
            registration_date_v1: "ວັນທີລົງທະບຽນ",
            registration_date_v2: "ວັນທີລົງທະບຽນ",
            registration_number: "ເລກລົງທະບຽນ",
            registration_number_v1: "ເລກລົງທະບຽນ",
            registration_number_v2: "ເລກລົງທະບຽນ",
            registration_type: "ປະເພດ",
            registration_type_v1: "ປະເພດ",
            registration_year_v1: "ປີທີ່ລົງທະບຽນ",
            registration_year_v2: "ປີທີ່ລົງທະບຽນ",
            request_change_description: "ຄຳອະທິບາຍຄຳຂໍປ່ຽນແປງ",
            request_change_description2: "ຄຳອະທິບາຍຄຳຂໍປ່ຽນແປງ",
            security_date: "ວັນທີຮັບປະກັນ",
            security_number: "ເລກໃບຮັບເງິນ",
            security_office: "ສຳນັກງານຮັບປະກັນ",
            security_serial: "ຊີເຣຍວຮັບປະກັນ",
            steer: "ພວງມາໄລ",
            to_date: "ຮອດວັນທີ",
            type: "ປະເພດ",
            vehicle_type: "ປະເພດ",
            verify_amend_description: "ຄຳອະທິບາຍ",
            year: "ປີ"
        }
    }
}